module.exports = __webpack_public_path__ + "44edb8da439546de4ad705480f2fa1c4.svg";